<template>
    <div class="pa-md-4" v-if="offers && offers.length && user.app_rating >= 4">
        <!-- <v-card-title class="headline" style="word-break: break-word;">
            {{$t('agitation.personal_offers')}}
        </v-card-title> -->
        <!-- <div class="pa-4">
                <OfferCards :offers="offers"></OfferCards>
        </div> -->
        <v-row v-bind:key="offer.id" v-for="(offer) in offers">
            <v-col cols="12">
                <Offer :offer="offer" is_clickable="true"></Offer>
            </v-col>
        </v-row>
    </div>
</template>

<script>
import OfferCards from "../../../offers/shared/components/offerCards";
import Offer from "../../../offers/shared/components/offer";

export default {
    name: 'PersonalOffersTemplate',
    components: {
        OfferCards,
        Offer,
    },
    computed: {
        user() {
            return this.$store.getters.AUTH_USER;
        },
        isSuccess() {
            return this.$store.getters.CLIENT_OFFERS_LOADING_SUCCESS;
        },
        offers() {
            return this.$store.getters.AGIT_OFFERS;
        },
    }
}
</script>

<style>

</style>